export default __webpack_public_path__ + "static/media/start-conversation.f95df40c.jpg";